import React from "react";
import { useState, useEffect } from "react";
import { api } from "../../../utlis/admin/api.utlis";
import { routes } from "../../../utlis/admin/routes.utlis";
import ApiService from "../../../core/services/ApiService";
import { Link, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import moment from "moment";
import "../../../../node_modules/react-datepicker/dist/react-datepicker.css";
import Loader from "../../../layouts/loader/Loader";
import NoImage from "../../../assets/admin/images/no-image.jpg";
import { encode } from "base-64";
import { totalPageCalculator, LIMIT } from "../../../utlis/common.utlis";

const Page = () => {
  const [providers, setProvider] = useState([]);
  const [categories, setCategory] = useState([]);
  const [states, setState] = useState([]);
  const [total, setTotal] = useState(0);
  const [pageNum, setPageNum] = useState(1);
  const [loading, setLoading] = useState(false);
  //const [totalPending, setTotalPending] = useState(0);

  const navigate = useNavigate();

  const [filters, setFilters] = useState({
    name: "",
    status: "",
    category: "",
    type: "",
    state_id: "",
    startDate: null,
    endDate: null,
    month: "",
    quarter: "",
    year: "",
  });
  const [dateType, setDateType] = useState("");

  const getStateList = async (api) => {
    const response = await ApiService.getAPIWithAccessToken(api);
    if (response.data.status && response.data.statusCode === 200) {
      setState(response.data.data.states);
    } else setState([]);
  };

  const getCategoryList = async (api) => {
    const response = await ApiService.getAPIWithAccessToken(api);
    if (response.data.status && response.data.statusCode === 200) {
      setCategory(response.data.data.categories);
    } else setCategory([]);
  };

  const handleFilterChange = (e, date = null) => {
    const { name, value } = e.target || {};
    const formattedDate = date ? moment(date).format("yyyy-MM-DD") : null;

    // Update the filters state
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: date === null ? value : formattedDate, // Use `value` for non-date fields, `formattedDate` for date fields
    }));
  };

  const handleSearch = () => {
    fetchFilteredData(filters); // Trigger search with current filters
  };

  const handleReset = () => {
    const resetFilters = {
      name: "",
      status: "",
      category: "",
      type: "",
      state_id: "",
      startDate: null,
      endDate: null,
      month: "",
      quarter: "",
      year: "",
    };

    setFilters(resetFilters);
    setDateType("");
    setPageNum(1);

    //console.log("Filters after Reset:", resetFilters);
    fetchFilteredData(resetFilters);
  };

  const fetchFilteredData = async (filterParams) => {
    const query = new URLSearchParams({
      page: pageNum,
      limit: LIMIT,
      search: filterParams.name,
      status: filterParams.status,
      categoryid: filterParams.category,
      user_type: filterParams.type,
      state_id: filterParams.state_id,
      startDate: filterParams.startDate,
      endDate: filterParams.endDate,
      month: filterParams.month,
      quarter: filterParams.quarter,
      year: filterParams.year,
    }).toString();

    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(`${api.providerList}?${query}`);
    if (response.data.status && response.data.statusCode === 200) {
      setProvider(response.data.data.providers);
      setTotal(response.data.data.total);
    } else {
      setProvider([]);
    }
    setLoading(false);
  };

  const handleDateTypeChange = (e) => {
    const value = e.target.value;

    // Clear all other date-related fields when selecting a new date_type
    setFilters((prevFilters) => ({
      ...prevFilters,
      startDate: null,
      endDate: null,
      month: value === "month" ? prevFilters.month : "",
      quarter: value === "quarter" ? prevFilters.quarter : "",
      year: value === "year" || value === "month" || value === "quarter" ? prevFilters.year : "",
    }));

    setDateType(value);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchData = async () => {
      const query = new URLSearchParams({
        page: pageNum,
        limit: LIMIT,
        /* search: filters.name,
        status: filters.status,
        categoryid: filters.category,
        user_type: filters.type,
        state_id: filters.state_id,
        startDate: filters.startDate,
        endDate: filters.endDate,
        month: filters.month,
        quarter: filters.quarter,
        year: filters.year, */
      }).toString();


      setLoading(true);
      const response = await ApiService.getAPIWithAccessToken(`${api.providerList}?${query}`);
      if (response.data.status && response.data.statusCode === 200) {
        setProvider(response.data.data.providers);
        setTotal(response.data.data.total);
      } else {
        setProvider([]);
      }
      setLoading(false);
    };

    fetchData();
    getCategoryList(api.categoryList);
    getStateList(api.stateList + `?country_id=231`);
  }, [pageNum]);

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="content-wrapper">
        <div className="care-title-header">
          <h2 className="heading-title mb-3">Provider/Staff Directory</h2>
          <div className="cc-search-filter">

          </div>
        </div>
        <div className="care-title-header">
          <div className="cc-search-filter wd100">
            <div className="row g-2">

              <div className="col-md-3">
                <div className="form-group">
                  <select
                    className="form-control"
                    name="category"
                    value={filters.category}
                    onChange={handleFilterChange}
                  >
                    <option value="">Select Category</option>
                    {categories.length !== 0
                      ? categories.map((ele, indx) => {
                        return (
                          <option key={indx} value={ele.id}>
                            {ele.name ?? "NA"}
                          </option>
                        );
                      })
                      : null}
                  </select>
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <select
                    className="form-control"
                    name="status"
                    value={filters.status}
                    onChange={handleFilterChange}
                  >
                    <option value="">Select Status</option>
                    <option value="0">Pending </option>
                    <option value="1">Active </option>
                    <option value="2">Inactive </option>
                  </select>
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <select
                    className="form-control"
                    name="type"
                    value={filters.type}
                    onChange={handleFilterChange}
                  >
                    <option value="">Select Type</option>
                    <option value="3">Care Staff</option>
                    <option value="2">Provider</option>
                  </select>
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group text-capitalize">
                  <select
                    className="form-control text-capitalize"
                    name="state_id"
                    value={filters.state_id}
                    onChange={handleFilterChange}
                  >
                    <option value="">Select State</option>
                    {states.length !== 0
                      ? states.map((ele, indx) => {
                        return (
                          <option key={indx} value={ele.id}>
                            {ele.name ?? "NA"}
                          </option>
                        );
                      })
                      : null}
                  </select>
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group search-form-group">
                  <input
                    type="text"
                    className="form-control ps-3"
                    placeholder="Search by Name"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    onChange={handleFilterChange}
                    name="name"
                    value={filters.name}
                  />
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <select
                    className="form-control"
                    name="date_type"
                    value={dateType}
                    onChange={handleDateTypeChange}
                  >
                    <option value="">Choose Date Range</option>
                    <option value="date">Date</option>
                    <option value="month">Month</option>
                    <option value="quarter">Quarter</option>
                    <option value="year">Year</option>
                  </select>
                </div>
              </div>

              {/* Conditionally Render Fields Based on Date Type */}
              {dateType === "date" && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      {/* From Date */}
                      <DatePicker
                        toggleCalendarOnIconClick
                        showIcon
                        dateFormat={"MM-dd-yyyy"}
                        selected={filters.startDate}
                        onChange={(date) =>
                          handleFilterChange({ target: { name: "startDate" } }, date)
                        }
                        className="DatePicker-control"
                        isClearable
                        autoComplete="off"
                        placeholderText="From Date"
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      {/* To Date */}
                      <DatePicker
                        toggleCalendarOnIconClick
                        showIcon
                        dateFormat={"MM-dd-yyyy"}
                        selected={filters.endDate}
                        onChange={(date) =>
                          handleFilterChange({ target: { name: "endDate" } }, date)
                        }
                        className="DatePicker-control"
                        isClearable
                        autoComplete="off"
                        placeholderText="To Date"
                      />
                    </div>
                  </div>
                </>
              )}

              {dateType === "month" && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      <select
                        className="form-control"
                        name="month"
                        value={filters.month}
                        onChange={handleFilterChange}
                      >
                        <option value="">Select Month</option>
                        <option value="1">January</option>
                        <option value="2">February</option>
                        <option value="3">March</option>
                        <option value="4">April</option>
                        <option value="5">May</option>
                        <option value="6">June</option>
                        <option value="7">July</option>
                        <option value="8">August</option>
                        <option value="9">September</option>
                        <option value="10">October</option>
                        <option value="11">November</option>
                        <option value="12">December</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <select
                        className="form-control"
                        name="year"
                        value={filters.year}
                        onChange={handleFilterChange}
                      >
                        <option value="">Select Year</option>
                        {Array.from({ length: 10 }, (_, i) => {
                          const year = new Date().getFullYear() - i;
                          return (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </>
              )}

              {dateType === "quarter" && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      <select
                        className="form-control"
                        name="quarter"
                        value={filters.quarter}
                        onChange={(e) => handleFilterChange(e)}
                      >
                        <option value="">All Quarters</option>
                        <option value="1">Q1 (Jan - Mar)</option>
                        <option value="2">Q2 (Apr - Jun)</option>
                        <option value="3">Q3 (Jul - Sep)</option>
                        <option value="4">Q4 (Oct - Dec)</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <select
                        className="form-control"
                        name="year"
                        value={filters.year}
                        onChange={(e) => handleFilterChange(e)}
                      >
                        <option value="">Select Year</option>
                        {Array.from({ length: 10 }, (_, i) => {
                          const year = new Date().getFullYear() - i;
                          return (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </>
              )}

              {dateType === "year" && (
                <div className="col-md-3">
                  <div className="form-group">
                    <select
                      className="form-control"
                      name="year"
                      value={filters.year}
                      onChange={(e) => handleFilterChange(e)}
                    >
                      <option value="">Select Year</option>
                      {Array.from({ length: 10 }, (_, i) => {
                        const year = new Date().getFullYear() - i;
                        return (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              )}

              <div className="col-md-2">
                <div className="form-group">
                  <button
                    className="btn btn-gr p-1"
                    onClick={handleSearch}
                  >
                    <i className="cc-input-group-text mdi mdi-magnify"></i>
                  </button> &nbsp;
                  <button
                    className="btn btn-re p-1"
                    onClick={handleReset}
                  >
                    <i className="cc-input-group-text mdi mdi-restore"></i>
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div className="carenetwork-content cc-table-card">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th> Name </th>
                  <th> Business Name </th>
                  <th> Type </th>
                  <th> Contact no. </th>
                  <th> Email ID </th>
                  <th> Category </th>
                  <th> Registered on </th>
                  <th> Status </th>
                  <th> Action </th>
                </tr>
              </thead>
              <tbody>
                {providers.length !== 0 ? (
                  providers.map((ele, indx) => {
                    return (
                      <tr key={indx}>
                        <td className="text-capitalize">
                          {ele.profile_image === null ||
                            ele.profile_image === "" ||
                            ele.profile_image === undefined ? (
                            <img src={NoImage} alt="" className="me-3" />
                          ) : (
                            <img
                              src={ele.profile_image}
                              alt=""
                              className="me-3"
                            />
                          )}
                          {ele?.name ?? "NA"}
                        </td>
                        <td className="text-capitalize">
                          {ele.logo === null ||
                            ele.logo === "" ||
                            ele.logo === undefined ? (
                            <img src={NoImage} alt="" className="me-3" />
                          ) : (
                            <img src={ele.logo} alt="" className="me-3" />
                          )}
                          {ele.business_name ?? "NA"}
                        </td>
                        <td> {ele.user_type_text ?? "NA"} </td>
                        <td> {ele.mobile ?? "NA"} </td>
                        <td className="text-lowercase">{ele.email ?? "NA"}</td>
                        <td> {ele.category ?? "NA"} </td>
                        <td>{moment(ele.created_date).format("MM-DD-yyyy")}</td>
                        <td> {ele.status} </td>
                        <td>
                          <Link
                            to=""
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(routes.providerDetails, {
                                state: {
                                  id: encode(ele.id),
                                },
                              });
                            }}
                          >
                            <label
                              style={{ cursor: "pointer" }}
                              className="badge badge-gradient-success"
                            >
                              <i className="fa fa-eye"></i>
                            </label>
                          </Link>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr className="text-center">
                    <td colSpan="9">
                      <div>
                        <p>No providers found</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="d-flex align-items-center justify-content-center mt-3">
              {providers.length !== 0 ? (
                <div className="care-table-pagination">
                  <ul className="care-pagination">
                    {pageNum !== 1 && (
                      <li
                        className="disabled"
                        id="example_previous"
                        onClick={() => setPageNum(pageNum - 1)}
                      >
                        <Link
                          to=""
                          aria-controls="example"
                          data-dt-idx="0"
                          tabIndex="0"
                          className="page-link"
                        >
                          Previous
                        </Link>
                      </li>
                    )}

                    {totalPageCalculator(total, LIMIT).length === 1
                      ? null
                      : totalPageCalculator(total, LIMIT).map(
                        (pageNo, indx) => {
                          return (
                            <li
                              className={pageNo === pageNum ? "active" : ""}
                              key={indx}
                              onClick={() => setPageNum(pageNo)}
                            >
                              <Link to="" className="page-link">
                                {pageNo}
                              </Link>
                            </li>
                          );
                        }
                      )}

                    {pageNum !== Math.ceil(total / LIMIT) && (
                      <li
                        className="next"
                        id="example_next"
                        onClick={() => setPageNum(pageNum + 1)}
                      >
                        <Link
                          to=""
                          aria-controls="example"
                          data-dt-idx="7"
                          tabIndex="0"
                          className="page-link"
                        >
                          Next
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Page;
